import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      width: "6",
      height: "10",
      viewBox: "0 0 6 10",
      fill: "none",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.292516 0.292893C-0.0980086 0.683418 -0.0980086 1.31658 0.292516 1.70711L3.12094 4.53553L0.292516 7.36396C-0.0980086 7.75449 -0.0980086 8.38765 0.292516 8.77817C0.68304 9.1687 1.31621 9.1687 1.70673 8.77817L5.24226 5.24264C5.63279 4.85212 5.63279 4.21895 5.24226 3.82843L1.70673 0.292893C1.31621 -0.0976311 0.68304 -0.0976311 0.292516 0.292893Z",
        fill: "#0468FF"
      })
    })
  );
}